export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q02_b.85fe05ea.png";